import { AllRejectionReasonsResponse, GrnRejectionReasonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { RejectioRreasonRequest } from './dto/grn-rejection-reason.request';
import { RejectionReasonsDto } from './dto/grn-rejection-reasons.dto';
import { GrnRejectionReasonsService } from './grn-rejection-reasons.service';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';

@Controller('grn-rejection-reasons')
@ApiTags('grn-rejection-reasons')
export class GrnRejectionReasonsController {
    constructor(
        private grnRejReasonService: GrnRejectionReasonsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      /**
     * creates  a Grn Rejection reason
     * @param RejectionReasonsDto Grn Rejection reason DTO
     * @returns Grn Rejection reasonResponse
     */
    @Post('/createGrnRejectionReason')
    async createGrnRejectionReason(@Body() grnRejReasondto:RejectionReasonsDto,isUpdate:boolean=false,@Req() request:Request): Promise<GrnRejectionReasonResponse> {
        try {
         return await this.grnRejReasonService.createGrnRejectionReason(grnRejReasondto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(GrnRejectionReasonResponse, error);
       }
     }

      /**
     * gets all the Value grn rejection reasons
     * @returns AllRejectionReasonsResponse which returns all the Value grn rejection reasons  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllGrnRejectionReasons')
    async getAllGrnRejectionReasons(@Body() req?:UserRequestDto): Promise<AllRejectionReasonsResponse> {
        try {
            return await this.grnRejReasonService.getAllGrnRejectionReasons(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllRejectionReasonsResponse, error);
        }
    }

     /**
     * Activate Or De-Activate Value grn rejection reason
     * @param getSingleGrnRejectionReason grn rejection reason 
     * @returns Value GrnRejectionReasonResponse
     */
   @Post('/activateOrDeactivateGrnRejectionReason')
   async activateOrDeactivateGrnRejectionReason(@Body() rejReasonReq: RejectioRreasonRequest): Promise<GrnRejectionReasonResponse> {
       try {
           return await this.grnRejReasonService.activateOrDeactivateGrnRejectionReason(rejReasonReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(GrnRejectionReasonResponse, err);
       }
   }

   /**
     *  updates a  value grn Rejection reason
     * @param RejectionReasonsDto RejectionReasonsDto DTO
     * @returns GrnRejectionReasonResponse
     */
    @Post('/updateGrnRejectionReason')
    async updateGrnRejectionReason(@Body() grnRejReasondto:RejectionReasonsDto,isUpdate:boolean=true,@Req() request:Request): Promise<GrnRejectionReasonResponse> {
        try {
         return await this.grnRejReasonService.createGrnRejectionReason(grnRejReasondto,true,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(GrnRejectionReasonResponse, error);
       }
     }
}
